import { Select } from "antd";

const { Option } = Select;

const styles = {
  container: {
    textAlign: "center",
    width: 250,
  },
  value: {
    textAlign: "center",
    fontSize: "min(max(13px, 1.4vw), 14px)",
  },
};

const CompetitionRounds = ({ rounds, current, onChangeRound }) => {
  return (
    <Select
      onChange={onChangeRound}
      value={JSON.stringify(current)}
      style={styles.container}
    >
      {rounds.map((round) => (
        <Option
          key={round.id}
          value={JSON.stringify(round)}
          style={styles.value}
        >
          {round.title}
        </Option>
      ))}
    </Select>
  );
};

export default CompetitionRounds;
